import service from '@/utils/request';
export var getAppList = function getAppList(data) {
  return service({
    url: "/app/getAppList",
    method: 'post',
    data: data
  });
};

// @Summary 获取渠道权限
// @Produce  application/json
// @Param {
//  page     int
//	pageSize int
// }
// @Router /app/appList [post]
export var getAppAuth = function getAppAuth(data) {
  return service({
    url: "/app/getAppAuth",
    method: 'post',
    data: data
  });
};

// @Summary 保存渠道权限
// @Produce  application/json
// @Param {
//  page     int
//	pageSize int
// }
// @Router /app/appList [post]
export var saveAppAuth = function saveAppAuth(data) {
  return service({
    url: "/app/saveAppAuth",
    method: 'post',
    data: data
  });
};
export var getAppInfo = function getAppInfo(data) {
  return service({
    url: "/app/getAppById",
    method: 'post',
    data: data
  });
};
export var updateApp = function updateApp(data) {
  return service({
    url: "/app/updateApp",
    method: 'post',
    data: data
  });
};
export var createApp = function createApp(data) {
  return service({
    url: "/app/createApp",
    method: 'post',
    data: data
  });
};
export var getGameCenterInfo = function getGameCenterInfo(data) {
  return service({
    url: "/app/getGameCenterCfgById",
    method: 'post',
    data: data
  });
};
export var updateGameCenter = function updateGameCenter(data) {
  return service({
    url: "/app/updateGameCenterCfg",
    method: 'post',
    data: data
  });
};